import React from 'react';

/**
 * Spool mascot for the guided tutorial.
 *
 * Drawn as SVG rather than a sprite sheet so the idle, blink and talking
 * animations can be driven by CSS, and so it stays crisp at any size.
 */
const TutorialMascot = ({ talking = false, cheering = false, size = 92 }) => (
  <div
    className={[
      'tutorial-mascot',
      talking ? 'is-talking' : '',
      cheering ? 'is-cheering' : '',
    ].filter(Boolean).join(' ')}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <svg viewBox="0 0 100 100" width={size} height={size}>
      <defs>
        <linearGradient id="mascot-body" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FF8FDC" />
          <stop offset="100%" stopColor="#F453C4" />
        </linearGradient>
        <linearGradient id="mascot-flange" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#9F6BF5" />
          <stop offset="100%" stopColor="#7C3AED" />
        </linearGradient>
      </defs>

      <ellipse className="mascot-shadow" cx="50" cy="92" rx="26" ry="5" />

      <g className="mascot-body-group">
        {/* Needle, tucked behind the spool like a held tool */}
        <g className="mascot-needle">
          <line x1="76" y1="64" x2="92" y2="30" stroke="#CBD5E1" strokeWidth="3" strokeLinecap="round" />
          <circle cx="92" cy="30" r="3.4" fill="none" stroke="#CBD5E1" strokeWidth="2" />
        </g>

        {/* Spool barrel */}
        <rect x="27" y="26" width="46" height="50" rx="7" fill="url(#mascot-body)" />

        {/* Wound thread */}
        <g className="mascot-thread" stroke="#FFFFFF" strokeWidth="1.6" strokeLinecap="round" opacity="0.35">
          <line x1="31" y1="38" x2="69" y2="34" />
          <line x1="31" y1="48" x2="69" y2="44" />
          <line x1="31" y1="58" x2="69" y2="54" />
          <line x1="31" y1="68" x2="69" y2="64" />
        </g>

        {/* Flanges */}
        <rect x="18" y="16" width="64" height="13" rx="6.5" fill="url(#mascot-flange)" />
        <rect x="18" y="73" width="64" height="13" rx="6.5" fill="url(#mascot-flange)" />

        {/* Face */}
        <g className="mascot-eyes">
          <ellipse className="mascot-eye" cx="41" cy="48" rx="6" ry="7" fill="#FFFFFF" />
          <ellipse className="mascot-eye" cx="59" cy="47" rx="6" ry="7" fill="#FFFFFF" />
          <circle cx="42.5" cy="49" r="3" fill="#2B1B4A" />
          <circle cx="60.5" cy="48" r="3" fill="#2B1B4A" />
          <circle cx="43.6" cy="47.6" r="1.1" fill="#FFFFFF" />
          <circle cx="61.6" cy="46.6" r="1.1" fill="#FFFFFF" />
        </g>

        <ellipse className="mascot-blush" cx="33" cy="58" rx="4" ry="2.6" fill="#FF4FA3" opacity="0.5" />
        <ellipse className="mascot-blush" cx="67" cy="57" rx="4" ry="2.6" fill="#FF4FA3" opacity="0.5" />

        <ellipse className="mascot-mouth" cx="50" cy="61" rx="4.6" ry="3.4" fill="#2B1B4A" />
      </g>
    </svg>
  </div>
);

export default TutorialMascot;
